module.exports = [
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 294.37
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 300.07
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 303.9
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 246.9
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 247.93
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 254.1
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 293.1
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 200.13
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 200.57
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 190.97
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 177.17
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 171.57
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 182.5
  },
  {
    "AgeGroup": "35-44 years",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 194.95
  }
]
